import React, { useState } from "react";
import "./AdminProjectInfo.css";
import { structureData } from "./adminFunction";

export default function AddOrder(props) {
  const { setList, list } = props;
  const [showList, setShowList] = useState(null); // Change to null to keep track of the clicked item index

  const handleQuantityChange = (item, e) => {
    const structureItem = structureData.find((i) => i.name === item.structureType);
    let value = e.target.value;
    if (value === "" || isNaN(parseFloat(value))) {
      value = 0;
    } else {
      let val = String(value);
      if (val[0] === "0" && val[1] !== "." && val.length > 1) {
        val = val.slice(1);
      }
      value = val;
    }
    setList((prevList) => {
      const updatedList = [...prevList];
      updatedList[item.id - 1] = {
        ...updatedList[item.id - 1],
        totalStructure: value,
        midClamp: value * structureItem.midClamp,
        endClamp: value * structureItem.endClamp
      };
      return updatedList;
    });
  };

  const handleStructure = (value, item) => {
    const structureItem = structureData.find((item) => item.name === value);
    setShowList(false);
    setList((prevList) => {
      const updatedList = [...prevList];
      updatedList[item.id - 1] = {
        ...updatedList[item.id - 1],
        structureType: value,
        articleName : structureItem.articleName,
        structureImage: structureItem.structureParts,
        price: structureItem.price,
      };
      return updatedList;
    });
  };

  const handleAddStructure = () => {
    const newId = list.length + 1; // Generate a new ID

    const newStructure = {
      id: newId,
      structureType: "Select",
      articleName: "",
      structureImage: "",
      totalStructure: 0,
      price: 0,
      midClamp: 0,
      endClamp: 0
    };

    setList((prevList) => [...prevList, newStructure]);
    console.log(list);
  };

  const handleRemoveStructure = (id) => {
    setList((prevList) => prevList.filter((item) => item.id !== id));
  };

  const handleToggleList = (index) => {
    setShowList((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <div className="orderDetails">
      {list.map((item, index) => (
        <div className="order" key={index}>
          <div className="product">
            <label>Mounting Structure</label>
            <div className="selectOption">
              <ul>
                <li onClick={() => handleToggleList(index)}>
                  {item.structureType}
                  <i className="bi bi-caret-down-fill"></i>
                </li>
                {showList === index && (
                  <div
                    className="dropDown"
                    onMouseLeave={() => setShowList(false)}
                  >
                    <span onClick={() => handleStructure("Smith P1", item)}>
                      Smith P1
                    </span>
                    <span onClick={() => handleStructure("Smith L1", item)}>
                      Smith L1
                    </span>
                    <span onClick={() => handleStructure("Smith L2", item)}>
                      Smith L2
                    </span>
                    <span onClick={() => handleStructure("Smith L3", item)}>
                      Smith L3
                    </span>
                    <span onClick={() => handleStructure("Smith Pro L", item)}>
                      Smith Pro L
                    </span>
                    <span onClick={() => handleStructure("Smith Pro P", item)}>
                      Smith Pro P
                    </span>
                    <span onClick={() => handleStructure("Smith ELITE(Carport)", item)}>
                      Smith ELITE(Carport)
                    </span>
                    
                  </div>
                )}
              </ul>
            </div>
          </div>
          <div className="quantity">
            <label>Quantity</label>
            <input
              type="number"
              name="quantity"
              value={item.quantity}
              onChange={(e) => handleQuantityChange(item, e)}
            />
          </div>
          <i
            className="bi bi-trash"
            onClick={() => handleRemoveStructure(item.id)}
          ></i>
        </div>
      ))}

      <button onClick={handleAddStructure}>+ Add Structure</button>
    </div>
  );
}
